<template>
  <div class="wrapper">
    <div class="questionTypeChoose" v-if="ifEdit">
      <div class="typeBtn typeBtnChoosen">
        {{ questionTypeList[parseInt(questionType) - 1] }}
      </div>
    </div>
    <div class="questionTypeChoose" v-if="!ifEdit">
      <div
        :class="['typeBtn', idx + 1 == questionType ? 'typeBtnChoosen' : '']"
        @click="typeSwitch(idx + 1)"
        v-for="(item, idx) in questionTypeList"
        :key="'typeBtn' + idx"
      >
        {{ item }}
      </div>
    </div>
    <div class="editorContainer">
      <h2>试题题干</h2>
      <div :ref="'content'"></div>
    </div>

    <el-upload
      ref="upload"
      accept="audio/mp3, audio/mp4a-latm, video/mp4"
      class="uploadContainer"
      :file-list="fileList"
      :headers="{ Authorization: getStore('accessToken'), accountId: 1 }"
      drag
      action
      :before-upload="uploadCheck"
      :http-request="ossUpload"
      :on-success="ossSuccess"
      :on-preview="handlePictureCardPreview"
      :before-remove="beforeDeleteUpload"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
      <div class="el-upload__tip" slot="tip">
        只能上传MP3/MP4文件，且不超过2Mb
      </div>
    </el-upload>
    <video
      style="max-height: 200px; max-width: 200px"
      controls
      :src="questionTemplate[questionType].videoUrl"
      v-if="questionTemplate[questionType].videoUrl"
    ></video>
    <audio
      controls
      :src="questionTemplate[questionType].audioUrl"
      v-if="questionTemplate[questionType].audioUrl"
    ></audio>
    <!-- 单选多选题 -->
    <div v-if="questionType == 2 || questionType == 1">
      <h2>答案选项</h2>
      <div
        class="editorContainer"
        v-for="(item, idx) in questionTemplate[questionType].answerDTOList"
        :key="'editor' + idx"
      >
        {{ `(${String.fromCharCode(64 + item.showNo)})` }}
        <el-button
          type="danger"
          icon="el-icon-delete"
          size="mini"
          style="margin: 10px"
          v-if="idx > 2"
          @click="removeAnswer(idx)"
        ></el-button>

        <div :ref="'answerEditor' + item.showNo" v-if="initComplete"></div>
      </div>
      <Button
        v-if="questionType != 4"
        icon="md-add-circle"
        type="default"
        @click="appendAnswer"
        >添加新选项</Button
      >
      <div class="inputBar">
        <Checkbox
          v-model="questionTemplate[questionType].isCustomScore"
          :true-value="1"
          :false-value="0"
          >允许选项自定义分数</Checkbox
        >
        <div
          class="selectSetBar"
          v-if="questionTemplate[questionType].isCustomScore == 1"
        >
          <div
            class="scoreBox"
            v-for="(item, idx) in questionTemplate[questionType].answerDTOList"
            :key="'selectScore' + idx"
          >
            <div>选项({{ String.fromCharCode(64 + item.showNo) }})的分数:</div>
            <el-input
              v-model="item.score"
              type="number"
              :min="0"
              size="small"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="inputBar">
        <Checkbox
          v-model="questionTemplate[questionType].combinationScore"
          :true-value="1"
          :false-value="0"
          >使用组合得分</Checkbox
        >
        <div v-if="questionTemplate[questionType].combinationScore == 1">
          <div
            class="combineBox"
            v-for="(combine, combineIdx) in questionTemplate[questionType]
              .combinationAnswerScore"
            :key="'combineGroup' + combineIdx"
          >
            <CheckboxGroup v-model="combine.answerIds" style="flex: 1">
              <Checkbox
                :label="select.id"
                v-for="select in questionTemplate[questionType].answerDTOList"
                :key="'combine' + select.showNo"
                border
              >
                {{ String.fromCharCode(64 + select.showNo) }}
              </Checkbox>
            </CheckboxGroup>
            <div class="inputSide">
              分数：<el-input
                size="small"
                v-model="combine.score"
                style="width: 100px"
              ></el-input>
              <el-button
                size="small"
                type="danger"
                @click="
                  questionTemplate[questionType].combinationAnswerScore.splice(
                    combineIdx,
                    1
                  )
                "
                >删除</el-button
              >
            </div>
          </div>
          <el-button
            type="primary "
            size="small"
            @click="
              questionTemplate[questionType].combinationAnswerScore.push({
                answerIds: [],
                score: 1,
              })
            "
            >添加组合</el-button
          >
        </div>
      </div>
    </div>
    <div class="editorContainer" v-else-if="questionType == 4">
      参考答案
      <div :ref="'consultAnswer'" v-if="initComplete"></div>
      <Checkbox
        v-model="questionTemplate[questionType].isAutomaticScore"
        :true-value="1"
        :false-value="0"
        >按关键字自动判分</Checkbox
      >
      <div class="tips">
        1.
        提前设定关键词，系统通过识别关键词来判断是否回答正确，考后系统自动出分。
        <br />2.
        如果没有勾选按关键词自动判分，考生答卷需等待管理员后台手工判分。
      </div>
      <Button
        type="primary"
        size="small"
        style="font-size: 12px"
        @click="addKeyword()"
        >添加关键字</Button
      >
      <div class="keywordBar">
        <div
          class="keyword"
          v-for="(keyword, kidx) in questionTemplate[questionType]
            .answerDTOList"
          :key="'keyword' + kidx"
          @mouseover="keyword.ifShow = true"
          @mouseout="keyword.ifShow = false"
        >
          {{ keyword.content }} &nbsp;&nbsp; {{ keyword.score }}分
          <div class="keywordHover" v-show="keyword.ifShow">
            <Icon
              type="ios-create-outline"
              size="18"
              @click="addKeyword(keyword)"
            />&nbsp;&nbsp;
            <Icon
              type="ios-trash"
              size="18"
              @click="removeKeyword(keyword, kidx)"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="questionType == 5">
      <div
        class="inputBar"
        v-for="(item, idx) in questionTemplate[questionType].answerDTOList"
        :key="'determine' + idx"
      >
        {{ ["", "真", "假"][item.showNo] }}
        <br />
        <Input v-model="item.content" style="width: 300px" />
      </div>
    </div>

    <div class="correctBar" v-if="![3, 4, 6].includes(questionType)">
      正确答案
      <RadioGroup
        :value="singleCorrect"
        @on-change="selectAnswer"
        v-if="questionType == 1 || questionType == 5"
      >
        <Radio
          :label="
            questionType == 5
              ? ['', '真', '假'][select.showNo]
              : String.fromCharCode(64 + select.showNo)
          "
          border
          v-for="select in questionTemplate[questionType].answerDTOList"
          :key="'select' + select.showNo"
        ></Radio>
      </RadioGroup>

      <CheckboxGroup
        v-model="multiSelectCorrectKey"
        @on-change="selectAnswer"
        v-if="questionType == 2"
      >
        <Checkbox
          :label="String.fromCharCode(64 + select.showNo)"
          v-for="select in questionTemplate[questionType].answerDTOList"
          :key="2 + select.showNo"
          border
        ></Checkbox>
      </CheckboxGroup>
    </div>
    <div class="correctBar" v-if="questionType == 3">
      要填的空和正确答案
      <div class="tips">
        下面列出了填空的个数，您需要在填空上写上正确答案。如果您的题含有不止一个空，您可以点击下面的按钮增加更多的空。
        <br />如果您的一个空可以 <strong>有多个正确答案</strong> ,
        正确答案请用竖线 | 分开，例如：大象|象
        <br />空旁边的分数表示该空答对时的得分， 如果留空，
        则填空题任何一空错了， 整题的分数都为0，如果不留空，则哪一空回答对，
        则得那空的分
      </div>
      <div
        class="longInputBar"
        v-for="(item, idx) in questionTemplate[questionType].answerDTOList"
        :key="'blankanswer' + idx"
      >
        ({{ String.fromCharCode(64 + item.showNo) }})
        <Row>
          <Col span="16">
            <Input
              v-model="item.content"
              placeholder="在这里写上该空的答案，如果有多个正确答案，请以竖线（|）分开"
            ></Input>
          </Col>
          <Col offset="1" span="3">
            <Input
              v-model="item.score"
              type="number"
              placeholder="得分"
            ></Input>
          </Col>
          <Col offset="1" span="3">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              v-if="idx > 0"
              @click="
                questionTemplate[questionType].answerDTOList.splice(idx, 1);
                questionTemplate[questionType].answerDTOList.forEach(
                  (item, idx) => (item.showNo = idx + 1)
                );
              "
            ></el-button>
          </Col>
        </Row>
      </div>

      <Button icon="md-add-circle" type="default" @click="appendAnswer"
        >新增填空</Button
      >
      <br />
      <Checkbox
        v-model="questionTemplate[questionType].isDisorder"
        :true-value="1"
        :false-value="0"
        >填空的答案无顺序要求</Checkbox
      >
      <br />
      <Checkbox
        v-model="questionTemplate[questionType].isByEmpty"
        :true-value="1"
        :false-value="0"
        >按空得分，只要一空答对就得分</Checkbox
      >
    </div>
    <div class="questionSelectBar" v-if="questionType == 6">
      <question-select
        :ifQuestion="true"
        :staticQuestionList="questionTemplate[6].questionDTOList"
        @eventUp="questionSelectEvent"
      ></question-select>
    </div>

    <div class="editorContainer">
      题目解析
      <div :ref="'analysis'"></div>
    </div>
    <!-- 分类 -->
    <div class="inputBar">
      试题分类
      <!-- <Input
        search
        enter-button="选择分类"
        placeholder="选择分类"
        :value="currentGroup.title"
        @on-search="typeChoose"
        readonly
        @on-focus="typeChoose"
      /> -->
      <treeinput
        :questionTypeTree="questionTypeTree"
        @treeEvent="treeEvent"
        :currentNodeId="questionTemplate[questionType].questionGroupId"
      ></treeinput>
      <!-- :currentGroup="currentGroup" -->
      <!-- questionTemplate[questionType].type -->
    </div>
    <!-- 可获得分数 -->
    <div class="inputBar">
      可获得分数
      <Input
        type="number"
        v-model="questionTemplate[questionType].score"
      ></Input>
    </div>
    <!-- 标签 -->
    <div class="inputBar">
      <el-select
        v-model="questionTemplate[questionType].questionLevelId"
        placeholder="请选择"
      >
        <el-option
          v-for="item in levelList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div class="actBar">
      <el-button @click="toCreateQuestion" type="primary">提交</el-button>
    </div>
    <Modal v-model="modelData.ifShow" title="编辑" @on-ok="keywordConfirm">
      <div v-show="modelData.ifInput">
        输入关键字:
        <input
          type="text"
          :placeholder="'请输入关键字'"
          v-model="modelData.value.content"
        />
      </div>
      <div v-show="modelData.ifInput">
        可获得分数:
        <input type="number" v-model="modelData.value.score" />
      </div>
    </Modal>

    <el-dialog
      title="提示"
      :visible.sync="uploadPreviewIfShow"
      :modal-append-to-body="false"
      center
    >
      <div>
        <video
          :src="uploadPreviewData.response.url"
          class="previewShow"
          controls
          autoplay
          v-if="
            uploadPreviewIfShow &&
            uploadPreviewData &&
            uploadPreviewData.raw.type.indexOf('video') > -1
          "
        ></video>

        <audio-player
          v-if="
            uploadPreviewIfShow &&
            uploadPreviewData &&
            uploadPreviewData.raw.type.indexOf('audio') > -1
          "
          :theUrl="uploadPreviewData.response.url"
        ></audio-player>
        <!-- <img :src="uploadPreviewData.response.url" class="previewShow" /> -->
      </div>
      <div slot="footer"></div>
    </el-dialog>
  </div>
</template>

<script>
import Editor from "wangeditor";
import audioPlayer from "@/views/my-components/audioPlayer.vue";
import questionSelect from "@/views/examination-management/component/examinationQuestionEdit.vue";
import {
  getQuestionType,
  createQuestion,
  getQuestionDetail,
  updateQuestion,
  renameQuestionType,
  deleteQuestionType,
  appendQuestionType,
  uploadSign,
  getLevelList,
} from "@/api/question.js";
// import oss from "ali-oss";
import treeinput from "@/component/tree/treeInput.vue";
let oss = require("ali-oss");
export default {
  components: { audioPlayer, treeinput, questionSelect },
  props: {},
  data() {
    return {
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      questionTypeList: [
        "单选题",
        "多选题",
        "填空题",
        "问答题",
        "判断题",
        "理解题",
      ],
      questionType: 1,
      levelList: [],
      questionTypeTree: [],
      editorList: [{}],
      questionTemplate: {
        1: {
          content: "",
          answerDTOList: [
            {
              questionId: "",
              showNo: 1,
              content: "",
              score: 1,
              editor: "",
              isCorrect: 1,
              questionTypeId: 1,
              css: [{ height: "83px" }],
            },
            {
              questionId: "",
              showNo: 2,
              content: "",
              score: 1,
              editor: "",
              isCorrect: 0,
              questionTypeId: 1,
              css: [{ height: "83px" }],
            },
            {
              questionId: "",
              showNo: 3,
              content: "",
              score: 1,
              editor: "",
              isCorrect: 0,
              questionTypeId: 1,
              css: [{ height: "83px" }],
            },
            {
              questionId: "",
              showNo: 4,
              content: "",
              score: 1,
              editor: "",
              isCorrect: 0,
              questionTypeId: 1,
              css: [{ height: "83px" }],
            },
          ],
          analysis: "",
          questionTypeId: 1,
          isAutomaticScore: 1,
          isCustomScore: 0,
          eventDetail: 0,
          correct: "",
          type: {},
          score: 1,
          audioUrl: "",
          audioDuration: "",
          videoUrl: "",
          videoDuration: "",
          questionGroupId: 1,
          questionLevelId: "",
        },
        2: {
          content: "",
          combinationScore: 0,
          combinationAnswerScore: [{ answerIds: [], score: 1 }],
          answerDTOList: [
            {
              questionId: "",
              showNo: 1,
              content: "",
              score: 1,
              editor: "",
              isCorrect: 0,
              questionTypeId: 2,
              css: [{ height: "83px" }],
            },
            {
              questionId: "",
              showNo: 2,
              content: "",
              score: 1,
              editor: "",
              isCorrect: 0,
              questionTypeId: 2,
              css: [{ height: "83px" }],
            },
            {
              questionId: "",
              showNo: 3,
              content: "",
              score: 1,
              editor: "",
              isCorrect: 0,
              questionTypeId: 2,
              css: [{ height: "83px" }],
            },
            {
              questionId: "",
              showNo: 4,
              content: "",
              score: 1,
              editor: "",
              isCorrect: 0,
              questionTypeId: 2,
              css: [{ height: "83px" }],
            },
          ],
          analysis: "",
          questionTypeId: 2,
          isAutomaticScore: 1,
          isCustomScore: 0,
          eventDetail: 0,
          correct: "",
          type: {},
          score: 1,
          audioUrl: "",
          audioDuration: "",
          videoUrl: "",
          videoDuration: "",
          questionGroupId: 1,
          questionLevelId: "",
        },
        5: {
          content: "",
          answerDTOList: [
            {
              questionId: "",
              showNo: 1,
              content: "",
              score: 1,
              editor: "",
              isCorrect: 1,
              questionTypeId: 5,
            },
            {
              questionId: "",
              showNo: 2,
              content: "",
              score: 1,
              editor: "",
              isCorrect: 0,
              questionTypeId: 5,
            },
          ],
          analysis: "",
          questionTypeId: 5,
          isAutomaticScore: 1,
          isCustomScore: 0,
          eventDetail: 0,
          correct: "",
          type: {},
          score: 1,
          audioUrl: "",
          audioDuration: "",
          videoUrl: "",
          videoDuration: "",
          questionGroupId: 1,
          questionLevelId: "",
        },
        3: {
          content: "",
          answerDTOList: [
            {
              questionId: "",
              showNo: 1,
              content: "",
              score: 1,
              isCorrect: 1,
              questionTypeId: 3,
            },
          ],
          analysis: "",
          questionTypeId: 3,
          isAutomaticScore: 1,
          isCustomScore: 0,
          eventDetail: 0,
          isDisorder: 1,
          isByEmpty: 1,
          correct: "",
          type: {},
          score: 1,
          audioUrl: "",
          audioDuration: "",
          videoUrl: "",
          videoDuration: "",
          questionGroupId: 1,
          questionLevelId: "",
        },
        4: {
          content: "",
          consultAnswer: "",
          answerDTOList: [],
          analysis: "",
          questionTypeId: 4,
          isAutomaticScore: 1,
          isCustomScore: 0,
          eventDetail: 0,
          correct: "",
          type: {},
          score: 1,
          audioUrl: "",
          audioDuration: "",
          videoUrl: "",
          videoDuration: "",
          questionGroupId: 1,
          questionLevelId: "",
        },
        6: {
          content: "",
          questionTypeId: 6,
          eventDetail: 0,
          type: {},
          childQuestionIds: [],
          questionDTOList: [],
          answerDTOList: [],
          score: 1,
          audioUrl: "",
          audioDuration: "",
          videoUrl: "",
          videoDuration: "",
          questionGroupId: 1,
          questionLevelId: "",
        },
      },
      modelData: {
        ifShow: false,
        ifInput: true,
        value: { content: "", score: 1 },
      },
      uploadPreviewData: {
        response: { url: "" },
        raw: { type: "" },
      },
      uploadPreviewIfShow: false,
      treeChooseShow: false,
      initComplete: true,
      temporaryData: "",
      multiSelectCorrectKey: [],
      ifEdit: false,
      OSS: "",
      ossData: {
        uploadHost: "http://cbsystem.oss-cn-shenzhen.aliyuncs.com",
      },
      ossHeader: {},
      labelChooseId: null,
    };
  },
  watch: {},
  computed: {
    singleCorrect() {
      let correctSelection = this.questionTemplate[
        this.questionType
      ].answerDTOList.find((item) => item.isCorrect == 1);
      // this.questionType==1?String.fromCharCode(64 +correctSelection.showNo)
      if (!correctSelection) {
        return null;
      } else {
        return this.questionType == 1
          ? String.fromCharCode(64 + correctSelection.showNo)
          : ["", "真", "假"][correctSelection.showNo];
      }
    },
  },
  methods: {
    combineCheck(...e) {
      console.log(e);
    },
    handleRemove(file) {
      console.log(file);
    },
    questionSelectEvent(data, options) {
      this.questionTemplate[6].childQuestionIds = data.map((item) => item.id);
      console.log(this.questionTemplate[6].childQuestionIds);
    },
    handlePictureCardPreview(file) {
      console.log(file);
      this.uploadPreviewData = file;
      this.dialogImageUrl = file.url;
      this.uploadPreviewIfShow = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    ossUpload(param) {
      var fileurl = URL.createObjectURL(param.file);
      //经测试，发现audio也可获取视频的时长
      var audioElement = new Audio(fileurl);
      audioElement.addEventListener("loadedmetadata", function (_event) {
        param.file.duration = audioElement.duration;
        console.log("duration" + param.file.duration + "s"); //单位：秒
      });
      return this.OSS.put(param.file.name, param.file);
    },
    ossSuccess(response, file, fileList) {
      let theVideo = null,
        theAudio = null,
        newFileList = [];
      if (file.raw.type.indexOf("video") > -1) {
        for (let question in this.questionTemplate) {
          this.questionTemplate[question].videoUrl = file.response.url;
          this.questionTemplate[question].videoDuration = file.raw.duration;
        }

        theAudio = fileList.find((item) => item.raw.type.indexOf("audio") > -1);

        if (theAudio) {
          newFileList.push(theAudio);
        }
        newFileList.push(file);
      } else {
        for (let question in this.questionTemplate) {
          this.questionTemplate[question].audioUrl = file.response.url;
          this.questionTemplate[question].audioDuration = file.raw.duration;
        }
        theVideo = fileList.find((item) => item.raw.type.indexOf("video") > -1);
        if (theVideo) {
          newFileList.push(theVideo);
        }
        newFileList.push(file);
      }
      this.fileList = newFileList;
      console.log(fileList, file, this.$refs.upload);
    },
    uploadPreview(a) {
      this.uploadPreviewIfShow = true;
      this.uploadPreviewData = a;
      // this.$set(this.$data, "uploadPreviewData", a);
      this.uploadPreviewData = a;
      console.log(a.raw.type);
    },
    uploadCheck(file) {
      console.log(file.type);
      if (file.type.indexOf("mp4") < 0 && file.type.indexOf("audio") < 0) {
        this.$message.error("为保证素材可用，请上传MP3或MP4格式文件");
        return false;
      }
    },
    beforeDeleteUpload(file) {
      if (file.raw.type.indexOf("video") > -1) {
        this.questionTemplate[this.questionType].videoUrl = "";
      } else if (file.raw.type.indexOf("audio") > -1) {
        this.questionTemplate[this.questionType].videoUrl = "";
      }
    },
    typeSwitch(type, ifForce) {
      if (type == this.questionType && !ifForce) {
        return;
      }
      if (this.questionType != 4) {
        this.questionTemplate[this.questionType].answerDTOList.forEach(
          (item) => {
            item.content = item.editor ? item.editor.txt.html() : item.content;
            item.editor = null;
          }
        );
      } else {
        this.questionTemplate[this.questionType].consultAnswer =
          this.questionTemplate[
            this.questionType
          ].consultAnswer.editor.txt.html() || "";
      }

      this.initComplete = false;
      this.questionType = type;
      this.$nextTick(() => {
        this.initComplete = true;
        setTimeout(this.editorInit, 100);
      });
    },
    editorInit(ifFirstInit = false) {
      let refList = ifFirstInit ? ["content", "analysis"] : [];
      let that = this;
      refList.forEach((item) => {
        let contentEditor = new Editor(this.$refs[item]);
        contentEditor.config.showFullScreen = false;
        contentEditor.config.menus = editorMenus;
        contentEditor.create();
        contentEditor.$textContainerElem.elems[0].style.height = "133px";
        if (this.questionTemplate[this.questionType][item]) {
          contentEditor.txt.html(
            this.questionTemplate[this.questionType][item]
          );
        }
        for (let question in this.questionTemplate) {
          this.questionTemplate[question][item] = {};
          this.questionTemplate[question][item].editor = contentEditor;
        }
        contentEditor.config.customUploadImg = function (
          resultFiles,
          insertImgFn
        ) {
          // resultFiles 是 input 中选中的文件列表
          // insertImgFn 是获取图片 url 后，插入到编辑器的方法
          resultFiles.forEach((item) => {
            console.log(item);
            let fileName = Date.now() + item.name;
            that.OSS.put(fileName, item);
            setTimeout(() => {
              insertImgFn(
                "https://cbsystem.oss-cn-shenzhen.aliyuncs.com/" + fileName
              );
            }, 100);
          });
          // 上传图片，返回结果，将图片插入到编辑器中
          // insertImgFn(imgUrl);
        };
      });
      // 问答题的参考答案富文本
      if (this.questionType == 4) {
        let consultAnswerEditor = new Editor(this.$refs.consultAnswer);
        consultAnswerEditor.config.menus = editorMenus;
        consultAnswerEditor.config.showFullScreen = false;
        consultAnswerEditor.create();
        consultAnswerEditor.$textContainerElem.elems[0].style.height = "88px";
        if (this.questionTemplate[this.questionType].consultAnswer) {
          consultAnswerEditor.txt.html(
            this.questionTemplate[this.questionType].consultAnswer
          );
        }
        this.questionTemplate[this.questionType].consultAnswer = {};
        this.questionTemplate[this.questionType].consultAnswer.editor =
          consultAnswerEditor;
      }

      if (this.questionType !== 2 && this.questionType !== 1) {
        return;
      }

      this.questionTemplate[this.questionType].answerDTOList.forEach((item) => {
        if (!item.editor) {
          console.log(
            this.$refs["answerEditor" + item.showNo],
            "answerEditor" + item.showNo
          );

          let answerEditor = new Editor(
            this.$refs["answerEditor" + item.showNo]
          );
          answerEditor.config.menus = editorMenus;
          answerEditor.config.showFullScreen = false;
          answerEditor.create();
          answerEditor.$textContainerElem.elems[0].style.height = "83px";

          if (item.content) {
            answerEditor.txt.html(item.content);
          }
          item.editor = answerEditor;
        }
      });
    },
    appendEditor(idx) {
      let theAnswer =
        this.questionTemplate[this.questionType].answerDTOList[
          this.questionTemplate[this.questionType].answerDTOList.length - 1
        ];
      let answerEditor = new Editor(
        this.$refs["answerEditor" + theAnswer.showNo]
      );
      answerEditor.config.showFullScreen = false;
      answerEditor.config.menus = editorMenus;
      answerEditor.create();
      theAnswer.css.forEach((css) => {
        for (let i in css) {
          answerEditor.$textContainerElem.elems[0].style[i] = css[i];
        }
      });
      theAnswer.editor = answerEditor;
    },
    selectAnswer(optionKey) {
      if (this.questionType == 1) {
        this.questionTemplate[this.questionType].answerDTOList.forEach(
          (cell) => {
            cell.isCorrect = optionKey.charCodeAt() - 64 == cell.showNo ? 1 : 0;
          }
        );
      } else if (this.questionType == 5) {
        this.questionTemplate[this.questionType].answerDTOList.forEach(
          (cell) => {
            cell.isCorrect = optionKey == ["", "真", "假"][cell.showNo] ? 1 : 0;
          }
        );
      } else {
        console.log(optionKey);
        this.questionTemplate[this.questionType].answerDTOList.forEach(
          (item) =>
            (item.isCorrect = optionKey.includes(
              String.fromCharCode(item.showNo + 64)
            )
              ? 1
              : 0)
        );
      }
    },
    treeEvent(eventDetail, treeData) {
      switch (eventDetail.type) {
        case "select":
          this.temporaryData = eventDetail.value;
          break;
        case "confirm":
          this.questionGroupConfirm();
          break;
        case "rename":
          renameQuestionType({
            id: eventDetail.contextData.id,
            parentId: eventDetail.contextData.parentId,
            newName: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("修改成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );

          break;
        case "delete":
          deleteQuestionType({
            id: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("删除成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );
          break;
        case "append":
          appendQuestionType({
            parentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("创建成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.success(data || "创建失败");
            }
          );
          break;
        case "move":
          moveQuestionType({
            id: eventDetail.id,
            newParentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("移动成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.success(data || "移动失败");
            }
          );
          break;

        default:
          break;
      }
    },
    questionGroupConfirm() {
      // console.log(this.temporaryData);
      this.$set(
        this.questionTemplate[this.questionType],
        "type",
        this.temporaryData
      );
      // this.questionTemplate[this.questionType].type = this.temporaryData;
      // console.log(this.questionTemplate[this.questionType].type);
      this.questionTemplate[this.questionType].questionGroupId =
        this.temporaryData.id;
    },
    questionTypeUpdate() {},
    typeChoose() {
      this.treeChooseShow = true;
    },
    // labelChoose(newLabel) {
    //   Object.keys(this.questionTemplate).forEach((key) => {
    //     this.questionTemplate[key].labelDTOList[0] = this.labelList.find(
    //       (item) => item.id == newLabel
    //     );
    //   });
    // },

    appendAnswer() {
      let answer = {
        questionId: "",
        // showNo: String.fromCharCode(
        //   65 + this.questionTemplate[this.questionType].answerDTOList.length
        // ),
        showNo:
          this.questionTemplate[this.questionType].answerDTOList.length + 1,
        content: "",
        score: 1,
        isCorrect: 1,
        questionTypeId: 1,
        css: [{ height: "83px" }],
      };
      this.questionTemplate[this.questionType].answerDTOList.push(answer);
      if (this.questionType == 1 || this.questionType == 2) {
        this.$nextTick(this.appendEditor);
      }
    },
    removeAnswer(id) {
      this.questionTemplate[this.questionType].answerDTOList.splice(id, 1);
      this.questionTemplate[this.questionType].answerDTOList.forEach(
        (item, idx) => (item.showNo = idx + 1)
      );
      this.typeSwitch(this.questionType, true);
    },
    addKeyword(keyword) {
      this.modelData = {
        ifNew: keyword ? false : true,
        ifShow: true,
        ifInput: true,
        value: {
          questionId: this.questionTemplate[this.questionType].id || 0,
          showNo:
            this.questionTemplate[this.questionType].answerDTOList.length + 1,
          content: "",
          score: 1,
          questionTypeId: 4,
          ifShow: false,
        },
      };
      Object.assign(this.modelData.value, keyword);
    },
    removeKeyword(keyword, kIdx) {
      this.questionTemplate[this.questionType].answerDTOList.splice(kIdx, 1);
    },
    keywordConfirm() {
      if (this.modelData.ifNew) {
        this.questionTemplate[this.questionType].answerDTOList.push(
          this.modelData.value
        );
      } else {
        this.questionTemplate[this.questionType].answerDTOList.forEach(
          (item) => {
            if (item.showNo == this.modelData.value.showNo) {
              item.content = this.modelData.value.content;
              item.score = this.modelData.value.score;
            }
          }
        );
      }
      this.modelData = {
        ifShow: false,
        ifInput: true,
        value: { content: "", score: 1 },
      };
    },
    toCreateQuestion() {
      let postData = {};
      if (this.ifDataError()) {
        return;
      }

      Object.assign(postData, this.questionTemplate[this.questionType]);

      if (this.questionType == 1 || this.questionType == 2) {
        // 富文本editor会有无限引用 showNo服务器要数字
        postData.answerDTOList = postData.answerDTOList.map((item, idx) => {
          let newItem = {};
          Object.assign(newItem, item);
          newItem.content = newItem.editor.txt.html();
          delete newItem.editor;
          return newItem;
        });
      }

      delete postData.type;
      if (this.questionType == 4) {
        postData.consultAnswer = postData.consultAnswer.editor.txt.html();
      }
      if (this.questionType == 6) {
        postData.childQuestionIds = postData.childQuestionIds.toString();
      }

      postData.content = postData.content.editor.txt.html();
      postData.analysis = postData.analysis.editor.txt.html();

      console.log(postData);
      if (this.ifEdit) {
        updateQuestion(postData).then(
          (data) => {
            console.log(data);
            this.$message.success("编辑成功");
            this.$router.go(-1);
          },
          (data) => console.log(data)
        );
      } else {
        createQuestion(postData).then(
          (data) => {
            console.log(data);
            this.$message.success("新建成功");
            this.$router.go(-1);
          },
          (data) => console.log(data)
        );
      }
    },
    getTextFromHtml(html) {
      return html.replace(/<[^<>]+>/g, "");
    },
    ifDataError() {
      let ifError = false;
      let questionData = this.questionTemplate[this.questionType];
      if (!questionData.content.editor.txt.text()) {
        this.$message.warning("请输入题干");
        return true;
      }
      // if (!questionData.analysis.editor.txt.text()) {
      //   this.$message.warning("请输入题目解析");
      //   return true;
      // }
      // 判断选项内容是否空
      for (let item of questionData.answerDTOList) {
        console.log(item);
        if (item.editor) {
          if (!item.editor.txt.text()) {
            console.log(item.editor.txt.text());
            this.$message.warning(
              `请补全${String.fromCharCode(64 + item.showNo)}选项内容`
            );
            ifError = true;
            break;
          }
        } else {
          if (!item.content) {
            console.log(item.content);
            this.$message.warning(
              `请补全${
                this.questionType == 5
                  ? [" 真 ", " 假 "][item.showNo - 1]
                  : String.fromCharCode(64 + item.showNo)
              }选项内容`
            );
            ifError = true;
            break;
          }
        }
      }
      // 判断是否勾选正确答案
      if (questionData.isCustomScore) {
        for (let que of questionData.answerDTOList) {
          if (!que.score && que.score != "0") {
            this.$message.warning(
              `请填写${String.fromCharCode(64 + que.showNo)}选项分数`
            );
            ifError = true;
            break;
          }
        }
      } else if (this.questionType == 5 || this.questionType == 1) {
        let correctCount = questionData.answerDTOList.reduce(
          (total, cur, arr) => {
            if (cur.isCorrect == 1) {
              total++;
            }
            return total;
          },
          0
        );
        if (correctCount != 1) {
          ifError = true;
          this.$message.warning("请选择一个正确答案");
        }
      } else if (this.questionType == 2) {
        if (questionData.answerDTOList.every((item) => item.isCorrect == 0)) {
          ifError = true;
          this.$message.warning("请选择至少一个正确答案");
        }
      }
      return ifError;
    },
    questionTypeInit() {
      getQuestionType().then((data) => {
        this.questionTypeTree = data.groupNodeList;
      });
    },
  },
  created() {},
  mounted() {
    // Object.assign(this.$data, this.$options.data());
    uploadSign().then((data) => {
      data.secure = true;
      this.OSS = new oss(data);
      Object.assign(this.ossData, data);
      console.log(this.OSS);
      this.ossHeader = {
        success_action_status: "201",
        OSSAccessKeyId: data.accessKeyId,
        policy: data.policy,
        Signature: data.signaturecom,
      };
    });
    getLevelList().then((data) => {
      this.levelList = data;
    });
    this.questionTypeInit();
    if (this.$route.query.id) {
      this.ifEdit = true;
      getQuestionDetail({ questionId: this.$route.query.id }).then((data) => {
        if (data.questionTypeId == 2) {
          this.multiSelectCorrectKey = data.answerDTOList
            .filter((item) => item.isCorrect == 1)
            .map((item) => String.fromCharCode(64 + item.showNo));
        }
        this.questionType = data.questionTypeId;
        this.questionTemplate[data.questionTypeId] = data;
        this.$forceUpdate(); // this.labelChooseId = data.labelDTOList[0].id;
        setTimeout(() => {
          this.questionTemplate[data.questionTypeId].type =
            this.questionTypeTree.find(
              (item) => item.id == data.questionGroupId
            );
          this.editorInit(true);
        }, 500);
      });
    } else {
      this.editorInit(true);
    }
  },
};
const editorMenus = [
  //   "head", // 标题
  "bold", // 粗体
  "fontSize", // 字号
  "fontName", // 字体
  "italic", // 斜体
  "underline", // 下划线
  "strikeThrough", // 删除线
  "foreColor", // 文字颜色
  "backColor", // 背景颜色
  //   "link", // 插入链接
  "list", // 列表
  "justify", // 对齐方式
  "quote", // 引用
  "image", // 插入图片
  // "table", // 表格
  // "video", // 插入视频
  // "code", // 插入代码
  "undo", // 撤销
  "redo", // 重复
];
</script>
<style lang="less" scoped>
.wrapper {
  padding: 30px;
  .questionTypeChoose {
    margin: 20px 0;
    .typeBtn {
      display: inline-block;
      height: 32px;
      line-height: 32px;
      margin-right: 3px;
      border: 1px solid #ff8100;
      padding: 0 6px;
    }
    .typeBtnChoosen {
      background: #ff8100 !important;
      color: #fff !important;
    }
  }
  .editorContainer {
    margin: 20px 0;
    width: 660px;
    /deep/ .w-e-toolbar {
      flex-wrap: wrap;
    }
    .keywordBar {
      .keyword {
        position: relative;
        display: inline-block;
        line-height: 24px;
        height: 24px;
        padding: 0 8px;
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid #ccc;
        font-size: 1rem;
        margin: 15px 3px;
        .keywordHover {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  .longInputBar {
    width: 660px;
    position: relative;
    margin: 20px 0;
  }
  .inputBar {
    width: 540px;
    position: relative;
    margin: 20px 0;
    .selectSetBar {
      display: flex;
      flex-flow: row wrap;
      .scoreBox {
        width: 120px;
        margin-right: 15px;
      }
    }
  }
}
.tips {
  padding: 15px 30px 15px 15px;
  margin: 20px 0;
  width: 480px;
  border-left: 5px solid #bbdba1;
  background-color: #eef7ea;
  color: #3c763d;
}
.uploadContainer {
  width: 660px;
}

.previewShow {
  max-width: 800px;
  max-height: 450px;
  display: block;
  margin: 0 auto;
}
.questionSelectBar {
  background: #fff;
  margin-top: 20px;
}
/deep/ .ivu-radio-inner {
  display: flex;
}
/deep/ .w-e-menu {
  z-index: 101 !important;
}
/deep/ .w-e-text-container {
  z-index: 100 !important;
}
.combineBox {
  display: flex;
  .inputSide {
    width: 200px;
  }
}
</style>